import React, { useState } from 'react';
import { Icon } from './icons.jsx';
import { ConfirmModal } from './shell.jsx';
// Página de Perfis de Acesso — somente Super Admin
const AccessProfilesPage = ({ onToast, logAction, internalUsers }) => {
  const PERMS_DEF = [
    { id: 'viewStores',     label: 'Visualizar lojas',                 group: 'Lojas'          },
    { id: 'editStores',     label: 'Editar dados de lojas',            group: 'Lojas'          },
    { id: 'suspendStores',  label: 'Suspender / ativar lojas',         group: 'Lojas'          },
    { id: 'impersonate',    label: 'Login como lojista',               group: 'Lojas'          },
    { id: 'viewFinancial',  label: 'Visualizar MRR e cobranças',       group: 'Financeiro'     },
    { id: 'editPlans',      label: 'Criar e editar planos',            group: 'Financeiro'     },
    { id: 'manageUsers',    label: 'Criar e editar usuários internos', group: 'Administração'  },
    { id: 'manageProfiles', label: 'Gerenciar perfis de acesso',       group: 'Administração'  },
    { id: 'viewAudit',      label: 'Visualizar logs de auditoria',     group: 'Administração'  },
    { id: 'globalConfig',   label: 'Alterar configurações globais',    group: 'Administração'  },
  ];

  const [profiles, setProfiles] = useState([
    {
      id: 'super_admin',
      name: 'Super Admin',
      description: 'Acesso total e irrestrito à plataforma, incluindo perfis e configurações críticas.',
      color: 'var(--danger)',
      colorBg: 'var(--danger-bg)',
      locked: true,
      permissions: Object.fromEntries(PERMS_DEF.map(p => [p.id, true])),
    },
    {
      id: 'admin',
      name: 'Admin',
      description: 'Gerencia lojas, planos e financeiro. Não pode alterar usuários internos nem perfis.',
      color: 'var(--info)',
      colorBg: 'var(--info-bg)',
      locked: false,
      permissions: { viewStores: true, editStores: true, suspendStores: true, impersonate: true, viewFinancial: true, editPlans: true, manageUsers: false, manageProfiles: false, viewAudit: true, globalConfig: false },
    },
    {
      id: 'suporte',
      name: 'Suporte',
      description: 'Visualiza lojas e usa impersonação. Não acessa financeiro nem configurações.',
      color: 'var(--success)',
      colorBg: 'var(--success-bg)',
      locked: false,
      permissions: { viewStores: true, editStores: false, suspendStores: false, impersonate: true, viewFinancial: false, editPlans: false, manageUsers: false, manageProfiles: false, viewAudit: true, globalConfig: false },
    },
  ]);

  const [drawerOpen,    setDrawerOpen]    = useState(false);
  const [editingProfile,setEditingProfile]= useState(null);
  const [confirmDelete, setConfirmDelete] = useState(null);

  const openCreate = () => { setEditingProfile(null); setDrawerOpen(true); };
  const openEdit   = (p)  => { setEditingProfile(p);  setDrawerOpen(true); };

  const handleSave = (saved) => {
    setProfiles(prev => {
      const idx = prev.findIndex(p => p.id === saved.id);
      if (idx >= 0) { const next = [...prev]; next[idx] = saved; return next; }
      return [...prev, saved];
    });
    setDrawerOpen(false);
    if (onToast) onToast(editingProfile ? `Perfil "${saved.name}" atualizado` : `Perfil "${saved.name}" criado`);
    if (logAction) logAction({ acao: editingProfile ? `Editou perfil ${saved.name}` : `Criou perfil ${saved.name}`, loja: '—', kind: 'info' });
  };

  const handleDelete = (profileId) => {
    const inUse = (internalUsers || []).filter(u => {
      const role = u.role?.toLowerCase().replace(' ', '_') || '';
      return role === profileId;
    }).length;
    if (inUse > 0) { if (onToast) onToast(`Não é possível excluir: ${inUse} usuário(s) com este perfil`); return; }
    setProfiles(prev => prev.filter(p => p.id !== profileId));
    if (onToast) onToast('Perfil removido');
    if (logAction) logAction({ acao: `Removeu perfil ${profileId}`, loja: '—', kind: 'danger' });
    setConfirmDelete(null);
  };

  const permGroups = [...new Set(PERMS_DEF.map(p => p.group))];

  const countPerms = (profile) => Object.values(profile.permissions).filter(Boolean).length;

  return (
    <div className="content" style={{ maxWidth: 1100 }}>
      <div className="page-header">
        <div>
          <h1>Perfis de acesso</h1>
          <p className="sub">Defina o que cada perfil pode ver e fazer no Super Admin · somente Super Admins podem alterar.</p>
        </div>
        <div className="actions">
          <button className="btn primary" onClick={openCreate}><Icon name="plus" size={14} />Novo perfil</button>
        </div>
      </div>

      {/* Cards de perfil */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 16, marginBottom: 32 }}>
        {profiles.map(profile => {
          const usersWithProfile = (internalUsers || []).filter(u =>
            (u.role || '').toLowerCase().replace(' ', '_') === profile.id
          );
          const enabledCount = countPerms(profile);
          return (
            <div key={profile.id} className="card" style={{ padding: 20 }}>
              {/* Header */}
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12, marginBottom: 14 }}>
                <div style={{ width: 40, height: 40, borderRadius: 10, background: profile.colorBg, color: profile.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, fontWeight: 700, flexShrink: 0 }}>
                  {profile.name.slice(0, 2).toUpperCase()}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 3 }}>
                    <div style={{ fontWeight: 700, fontSize: 15 }}>{profile.name}</div>
                    {profile.locked && <span style={{ fontSize: 10, fontWeight: 600, padding: '2px 7px', background: profile.colorBg, color: profile.color, borderRadius: 20, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Sistema</span>}
                  </div>
                  <div style={{ fontSize: 12, color: 'var(--text-muted)', lineHeight: 1.4 }}>{profile.description}</div>
                </div>
                <div style={{ display: 'flex', gap: 2, flexShrink: 0 }}>
                  {!profile.locked && <>
                    <button className="icon-action" title="Editar perfil" onClick={() => openEdit(profile)}><Icon name="edit" size={13} /></button>
                    <button className="icon-action danger" title="Excluir perfil" onClick={() => setConfirmDelete(profile)}><Icon name="x" size={13} /></button>
                  </>}
                  {profile.locked && <span style={{ fontSize: 11, color: 'var(--text-muted)', padding: '4px 6px' }}>🔒</span>}
                </div>
              </div>

              {/* Contador de permissões */}
              <div style={{ borderTop: '1px solid var(--border)', paddingTop: 12, marginBottom: 12 }}>
                <div style={{ fontSize: 12, color: 'var(--text-muted)', display: 'flex', alignItems: 'center', gap: 8 }}>
                  <div style={{ flex: 1, height: 4, borderRadius: 2, background: 'var(--border)' }}>
                    <div style={{ height: '100%', borderRadius: 2, background: profile.color, width: `${Math.round(enabledCount / PERMS_DEF.length * 100)}%`, transition: 'width 300ms' }} />
                  </div>
                  <span style={{ fontWeight: 600, color: profile.color, flexShrink: 0 }}>{enabledCount}</span>
                  <span style={{ flexShrink: 0 }}>/ {PERMS_DEF.length} permissões</span>
                </div>
              </div>

              {/* Usuários com este perfil */}
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <div style={{ display: 'flex', gap: -4 }}>
                  {usersWithProfile.slice(0, 4).map((u, i) => (
                    <div key={u.email} title={u.name} style={{
                      width: 24, height: 24, borderRadius: '50%',
                      background: 'var(--brand-navy)', color: 'white',
                      fontSize: 10, fontWeight: 600,
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      border: '2px solid var(--bg-elevated)',
                      marginLeft: i === 0 ? 0 : -8,
                      zIndex: 4 - i,
                      position: 'relative',
                    }}>
                      {u.name.split(' ').map(n => n[0]).slice(0, 2).join('')}
                    </div>
                  ))}
                </div>
                <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>
                  {usersWithProfile.length === 0 ? 'Nenhum usuário' : `${usersWithProfile.length} usuário${usersWithProfile.length !== 1 ? 's' : ''}`}
                </span>
              </div>
            </div>
          );
        })}

        {/* Card novo perfil */}
        <div
          className="card"
          style={{ padding: 20, border: '1.5px dashed var(--border-strong)', background: 'transparent', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 8, cursor: 'pointer', color: 'var(--text-muted)', minHeight: 200 }}
          onClick={openCreate}
        >
          <div style={{ width: 40, height: 40, borderRadius: '50%', background: 'var(--bg-subtle)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Icon name="plus" size={20} />
          </div>
          <span style={{ fontSize: 13, fontWeight: 500 }}>Novo perfil</span>
          <span style={{ fontSize: 12, color: 'var(--text-muted)', textAlign: 'center' }}>Crie um perfil com permissões personalizadas</span>
        </div>
      </div>

      {/* Tabela comparativa */}
      <div className="card">
        <div className="card-head">
          <h3>Comparativo de permissões</h3>
          <span className="sub">Visão geral de todos os perfis</span>
        </div>
        <div style={{ overflowX: 'auto' }}>
          <table className="data">
            <thead>
              <tr>
                <th style={{ minWidth: 220 }}>Permissão</th>
                {profiles.map(p => (
                  <th key={p.id} style={{ textAlign: 'center', minWidth: 120 }}>
                    <span style={{ color: p.color, fontWeight: 600 }}>{p.name}</span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {permGroups.map(group => (
                <React.Fragment key={group}>
                  <tr>
                    <td colSpan={profiles.length + 1} style={{ background: 'var(--bg-subtle)', fontSize: 11, fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.06em', padding: '8px 16px' }}>
                      {group}
                    </td>
                  </tr>
                  {PERMS_DEF.filter(p => p.group === group).map(perm => (
                    <tr key={perm.id}>
                      <td style={{ fontSize: 13 }}>{perm.label}</td>
                      {profiles.map(profile => {
                        const active = profile.locked || !!profile.permissions[perm.id];
                        return (
                          <td key={profile.id} style={{ textAlign: 'center' }}>
                            {active
                              ? <Icon name="check" size={16} style={{ color: 'var(--success)' }} />
                              : <span style={{ color: 'var(--text-disabled)', fontSize: 16 }}>—</span>
                            }
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Confirm delete */}
      <ConfirmModal
        open={!!confirmDelete}
        onClose={() => setConfirmDelete(null)}
        onConfirm={() => handleDelete(confirmDelete?.id)}
        title={`Excluir perfil "${confirmDelete?.name}"?`}
        body={<>Usuários com este perfil perderão o acesso associado. <strong>Esta ação não pode ser desfeita.</strong></>}
        confirmLabel="Excluir perfil"
        danger={true}
      />

      {/* Drawer de criar/editar */}
      <ProfileEditorDrawer
        open={drawerOpen}
        profile={editingProfile}
        perms={PERMS_DEF}
        onClose={() => setDrawerOpen(false)}
        onSave={handleSave}
      />
    </div>
  );
};

// ── Drawer de edição de perfil ────────────────────────────────────────────────
const ProfileEditorDrawer = ({ open, profile, perms, onClose, onSave }) => {
  const isNew = !profile;
  const [form, setForm] = useState({
    name: '', description: '', color: 'var(--info)', colorBg: 'var(--info-bg)',
    permissions: Object.fromEntries(perms.map(p => [p.id, false])),
  });
  const [errors, setErrors] = useState({});

  React.useEffect(() => {
    if (open) {
      if (profile) {
        setForm({ name: profile.name, description: profile.description, color: profile.color, colorBg: profile.colorBg, permissions: { ...profile.permissions } });
      } else {
        setForm({ name: '', description: '', color: 'var(--info)', colorBg: 'var(--info-bg)', permissions: Object.fromEntries(perms.map(p => [p.id, false])) });
      }
      setErrors({});
    }
  }, [open, profile]);

  if (!open) return null;

  const togglePerm = (id) => setForm(f => ({ ...f, permissions: { ...f.permissions, [id]: !f.permissions[id] } }));

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = 'Nome é obrigatório';
    return e;
  };

  const handleSave = () => {
    const e = validate();
    if (Object.keys(e).length) { setErrors(e); return; }
    onSave({
      ...profile,
      id:          profile?.id || form.name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]+/g,'_'),
      name:        form.name,
      description: form.description,
      color:       form.color,
      colorBg:     form.colorBg,
      locked:      false,
      permissions: form.permissions,
    });
  };

  const COLORS = [
    { color: 'var(--info)',    colorBg: 'var(--info-bg)',    label: 'Azul'   },
    { color: 'var(--success)', colorBg: 'var(--success-bg)', label: 'Verde'  },
    { color: 'var(--warning)', colorBg: 'var(--warning-bg)', label: 'Âmbar'  },
    { color: 'var(--danger)',  colorBg: 'var(--danger-bg)',  label: 'Vermelho'},
    { color: 'var(--text-secondary)', colorBg: 'var(--bg-subtle)', label: 'Neutro' },
  ];

  const permGroups = [...new Set(perms.map(p => p.group))];
  const inp = { width: '100%', height: 36, padding: '0 12px', borderRadius: 8, border: '1px solid var(--border-strong)', background: 'var(--bg-elevated)', color: 'var(--text)', fontSize: 13, fontFamily: 'inherit' };
  const inpE = { ...inp, borderColor: 'var(--brand-red)' };
  const enabledCount = Object.values(form.permissions).filter(Boolean).length;

  return (
    <>
      <div className="drawer-overlay" onClick={onClose} />
      <div className="drawer" style={{ width: 520 }}>
        <div className="drawer-head">
          <div style={{ width: 36, height: 36, borderRadius: 8, background: form.colorBg, color: form.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 700 }}>
            {form.name ? form.name.slice(0, 2).toUpperCase() : <Icon name="users" size={16} />}
          </div>
          <div style={{ flex: 1 }}>
            <h3>{isNew ? 'Novo perfil de acesso' : `Editar perfil ${profile.name}`}</h3>
            <div className="sub">{enabledCount} permissão{enabledCount !== 1 ? 'ões' : ''} ativa{enabledCount !== 1 ? 's' : ''}</div>
          </div>
          <button className="icon-action" onClick={onClose} style={{ width: 32, height: 32 }}><Icon name="x" size={16} /></button>
        </div>

        <div className="drawer-body">
          {/* Identificação */}
          <div className="drawer-section">
            <h4>Identificação</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              <div>
                <div style={{ fontSize: 12, fontWeight: 500, color: 'var(--text-secondary)', marginBottom: 5 }}>Nome do perfil<span style={{ color: 'var(--brand-red)', marginLeft: 2 }}>*</span></div>
                <input style={errors.name ? inpE : inp} value={form.name} onChange={e => { setForm(f => ({ ...f, name: e.target.value })); if (errors.name) setErrors(v => ({ ...v, name: null })); }} placeholder="Ex: Financeiro, Operações..." />
                {errors.name && <div style={{ fontSize: 11, color: 'var(--brand-red)', marginTop: 3 }}>{errors.name}</div>}
              </div>
              <div>
                <div style={{ fontSize: 12, fontWeight: 500, color: 'var(--text-secondary)', marginBottom: 5 }}>Descrição</div>
                <input style={inp} value={form.description} onChange={e => setForm(f => ({ ...f, description: e.target.value }))} placeholder="Descreva o escopo deste perfil" />
              </div>
              <div>
                <div style={{ fontSize: 12, fontWeight: 500, color: 'var(--text-secondary)', marginBottom: 8 }}>Cor do perfil</div>
                <div style={{ display: 'flex', gap: 8 }}>
                  {COLORS.map(c => (
                    <div key={c.label} onClick={() => setForm(f => ({ ...f, color: c.color, colorBg: c.colorBg }))} title={c.label} style={{
                      width: 28, height: 28, borderRadius: '50%', cursor: 'pointer',
                      background: c.colorBg, border: `2px solid ${form.color === c.color ? c.color : 'transparent'}`,
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                    }}>
                      <div style={{ width: 12, height: 12, borderRadius: '50%', background: c.color }} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Permissões */}
          {permGroups.map(group => (
            <div key={group} className="drawer-section">
              <h4>{group}</h4>
              <div style={{ display: 'flex', flexDirection: 'column', borderRadius: 'var(--radius)', overflow: 'hidden', border: '1px solid var(--border)' }}>
                {perms.filter(p => p.group === group).map((p, i, arr) => {
                  const checked = !!form.permissions[p.id];
                  return (
                    <label key={p.id} style={{
                      display: 'flex', alignItems: 'center', gap: 12, padding: '11px 14px',
                      borderBottom: i < arr.length - 1 ? '1px solid var(--border)' : 'none',
                      cursor: 'pointer',
                      background: checked ? `color-mix(in srgb, ${form.color} 5%, var(--bg-elevated))` : 'var(--bg-elevated)',
                      transition: 'background 100ms',
                    }}>
                      <input type="checkbox" checked={checked} onChange={() => togglePerm(p.id)}
                        style={{ width: 15, height: 15, accentColor: 'var(--brand-navy)', flexShrink: 0 }} />
                      <span style={{ fontSize: 13, color: checked ? 'var(--text)' : 'var(--text-secondary)' }}>{p.label}</span>
                    </label>
                  );
                })}
              </div>
            </div>
          ))}
        </div>

        <div className="drawer-foot">
          <span className="note">{isNew ? 'O perfil ficará disponível para atribuição imediatamente.' : 'Alterações aplicadas imediatamente aos usuários com este perfil.'}</span>
          <button className="btn ghost" onClick={onClose}>Cancelar</button>
          <button className="btn primary" onClick={handleSave}>
            {isNew ? <><Icon name="plus" size={14} />Criar perfil</> : <><Icon name="check" size={14} />Salvar</>}
          </button>
        </div>
      </div>
    </>
  );
};

export {
  AccessProfilesPage,
};
